<template>
	<div class="allbigbox">
		<div class="header">
			<div @click="closeallmessage" class="imback"><i class="el-icon-back"></i></div>
			<span @click="close" class="close">
				<i class="el-icon-close"></i>
			</span>
		</div>
		<div class="timebox">
			<div class="timetitle">時間：</div>
			<div class="tileselect">
				<el-select @change="timegetmessage" v-model="time" placeholder="請選擇">
					<el-option v-for="t in timelist" :key="t.value" :label="t.label" :value="t.value">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="
					 messbox">
			<div v-if="dataList">
				<template v-for="(item,ordernum) in dataList">
					<ul class="messgaelist">
						<li>
							<div class="ordernum">{{ordernum}}</div>
							<ul class="msggroup">
								<li @click.stop="Details(msg.order_id,msg.id)" v-for="msg in item">
									<div class="libox">
										<div class="userbox">
											<div class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+apiurl+msg.from_thumb+')'}"></div>
											<span v-if="msg.to_view == 0 && msg.from_id != user_id" class="newmes">new</span>
										</div>

										<div class="msbox">
											<div class="msheader">
												<div class="username">{{msg.from_username}}</div>
												<div class="addtime">{{msg.addtime}}</div>
											</div>
											<div class="mscontentbox">
												<div class="mscontent">
													<div><span v-if="msg.replay == 1">回復：</span>{{msg.content}}</div>
													<div>
														<div v-if="(msg.from_id == user_id) && (msg.replay == 0)" class="frommsg">(你發送給{{msg.to_username}})</div>
														<div v-else-if="(msg.from_id == user_id) && (msg.replay == 1)" class="frommsg">(你回復給{{msg.to_username}})</div>
													</div>
												</div>

											</div>

										</div>
									</div>
								</li>

							</ul>
						</li>
					</ul>
				</template>
			</div>
			<div v-else>
				<el-card shadow="never">
					<p class="text-align-center">
						暫無信息！
					</p>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				dataList: {},
				timelist: [{
						value: 7,
						label: '7天内'
					}, {
						value: 14,
						label: '14天内'
					}, {
						value: 30,
						label: '30天内'
					},
					{
						value: 90,
						label: '90天内'
					},
				],
				time: 7
			}
		},

		methods: {
			getmessage() {
				let user_id = parseInt(sessionStorage.getItem('user_id'));
				this.post('/api/message/allmessage', {
					time:this.time,
					to_id: user_id
				}).then((res) => {
					
					this.dataList = res;
				})
			},
			timegetmessage(time){
				let user_id = parseInt(sessionStorage.getItem('user_id'));
				this.post('/api/message/allmessage', {
					time:time,
					to_id: user_id
				}).then((res) => {
					
					this.dataList = res;
				})
			},
			closeallmessage(){
				this.$emit('closeallmessage', false);
			},
			close() {
				
				this.$emit('closemsgcenter', false);
			},


		},
		created() {
			this.user_id = parseInt(sessionStorage.getItem('user_id'));

			this.getmessage();
		}
	}
</script>

<style scoped="">
	.imback {
		font-size: 28px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3399ff;
	}
	.timetitle {
		font-weight: bold;
	}

	.timebox {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px;
	}

	.addtime {
		font-size: 12px;
		color: #999;
	}

	.username {
		font-weight: bold;
	}


	.newmes {
		color: #fff;
		background: #f60;
		padding: 2px 5px;
		margin-left: 4px;
	}

	.frommsg {
		font-size: 12px;
		color: #a1a1a1;
	}

	.messtoolbox {
		position: absolute;
		background: #fff;
		left: -50px;
		top: 20px;
		border: 1px solid #e2e2e2;
		z-index: 1;
	}

	.messtoolbox>li {
		height: 25px;
		line-height: 25px;
		width: 80px;
		text-align: center;
	}

	.ordernum {
		color: #3b3bff;
		background: #f2f2f2;
		margin-bottom: 10px;
		padding: 5px;
		padding-left: 15px;
	}

	.header {
		padding: 15px;
		display: flex;
		justify-content: space-between;
	}

	.msstitle {
		text-align: center;
	}

	.messbox {
		height: calc(100vh - 140px);
		overflow-x: hidden;
		padding: 0 15px;
	}

	.mscontentbox {
		display: flex;
		justify-content: space-between;
		padding: 10px 0;
	}

	.mscontent {
		text-align: justify;
	}

	.msbox {
		flex: 1 auto;
	}

	.msright {
		flex: 0 30px;
		position: relative;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
	}

	.msright i {
		font-size: 23px;
		color: #666666;
		position: absolute;
		top: -4px;
		left: 10px;
	}

	.msheader {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.messgaelist .libox {
		display: flex;
	}

	.messgaelist>li {}

	.msggroup>li:last-child {
		margin-bottom: 10px;
	}

	.libox {
		padding: 10px;
	}

	.libox.active {
		background-color: #F0F5FA
	}

	.userbox {
		flex: 0 0 45px;
	}

	.userface {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.clearmessage {
		padding: 2px 15px;
		background: #3399ff;
		border-radius: 4px;
		color: #fff;
		cursor: pointer;
	}

	.messagehader {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 15px 15px 15px;
	}

	.close {
		border-radius: 50%;
		font-size: 18px;
		width: 25px;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #3399ff;
		color: #fff;
	}

	.allbigbox {
		position: relative;
		background: #fff;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: calc(100vh - 55px);
		
	}

	.header {
		padding: 15px;
		display: flex;
		justify-content: space-between;
		position: relative;
		border-bottom: 1px solid #e2e2e2;
	}
</style>
